/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsRetailerLoginViewProps } from '../../../modules/hosports-retailer-login/./hosports-retailer-login';
import RetailerLogin from "./../../../baseComponents/retailer-login/./retailer-login";

export default (props: IHosportsRetailerLoginViewProps) => {
  let config = props.config;
  let username = 'hyperlite-retailer';
  let backgroundImage = config.backgroundImage ? config.backgroundImage.src : undefined;
  if(config.brand == 'hosports'){
    username = 'hosports-retailer';
  }
    return (
        <RetailerLogin
          title={config.title}
          subtitle={config.subtitle}
          username={username}
          backgroundImage={backgroundImage}
        />
    );
};
